import withSpacing from '../hooks/withSpacing';
import React, { useEffect } from 'react';
import {
  WHITE_LABEL_ACCENT_COLOR,
  WHITE_LABEL_MARKET,
  WHITE_LABEL_STRIPE_PROMISE,
} from '../lib/white-label';
import { Elements } from '@stripe/react-stripe-js';
import { useQuery } from '@apollo/client';
import { SELLER_PAYMENT_INTENT } from '../lib/graphql/queries';
import PurchaseForm from '../components/reactivate-listings/PurchaseForm';
import Loading from '../components/Loading';
import { TidalButton } from '../components/common/button';
import { useRouter } from 'next/router';
import { analytics } from '../lib/analytics';

const ReactivateListings = () => {
  const { data, loading } = useQuery(SELLER_PAYMENT_INTENT);
  const router = useRouter();

  useEffect(() => {
    analytics.page('Reactivate Listings');
  }, []);

  const paymentIntent = data?.me?.sellerVerificationPaymentIntent;
  const needsPaymentMethod = !loading && !!paymentIntent;

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="w-full flex flex-col items-center gap-10">
      <div className="w-3/4 text-center">
        <p className="text-2xl">
          {needsPaymentMethod
            ? 'Your listings have been temporarily disabled.'
            : 'Your listings have been re-enabled.'}
        </p>
      </div>
      <div className="w-3/4 text-center flex flex-col items-center gap-y-4">
        {needsPaymentMethod && (
          <>
            <p className="text-xl">
              To re-activate your listings you must provide a payment method.
            </p>
            <div>
              <p className="text-xs font-light text-gray-500 text-left">
                This is provided to ensure Buyer Protection on all{' '}
                {WHITE_LABEL_MARKET} orders.
              </p>
            </div>
            <div className="w-3/4 mt-5">
              <Elements
                options={{
                  clientSecret: paymentIntent,
                  appearance: {
                    theme: 'stripe',
                    variables: {
                      colorPrimary: WHITE_LABEL_ACCENT_COLOR,
                      fontFamily: 'Poppins, sans-serif',
                    },
                    rules: {},
                  },
                  loader: 'always',
                }}
                stripe={WHITE_LABEL_STRIPE_PROMISE}
              >
                <PurchaseForm intentSecret={paymentIntent} />
              </Elements>
            </div>
          </>
        )}
        {!needsPaymentMethod && (
          <TidalButton
            text="Go home"
            onClick={() => router.push('/')}
            type="info"
            tint={false}
            className="w-1/2 m-auto"
          />
        )}
      </div>
    </div>
  );
};

export default withSpacing(ReactivateListings);
